<template>
  <div>
    <el-row>
      <el-col :span="24">
        <depository-message></depository-message>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <depository-search></depository-search>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7">
        <depository-sections></depository-sections>
      </el-col>
      <el-col :span="16" :offset="1">
        <depository-list></depository-list>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import DepositorySearch from './DepositorySearch'
  import DepositorySections from './DepositorySections'
  import DepositoryList from './DepositoryList'
  import DepositoryMessage from './DepositoryMessage'
  export default {
    name: 'Depository',
    created: function () {
      this.fillData()
    },
    components: {
      DepositorySearch,
      DepositorySections,
      DepositoryList,
      DepositoryMessage
    },
    methods: {
      ...mapActions('depository', [
        'fillData'
      ])
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Depository.vue